import script from "./Agreements.vue?vue&type=script&setup=true&lang=js"
export * from "./Agreements.vue?vue&type=script&setup=true&lang=js"

import "./Agreements.vue?vue&type=style&index=0&id=2012bf9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2012bf9e"]])

export default __exports__